import { render, staticRenderFns } from "./OrganizationCampaignsView.vue?vue&type=template&id=e9dfff0a&scoped=true&"
import script from "./OrganizationCampaignsView.vue?vue&type=script&lang=js&"
export * from "./OrganizationCampaignsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9dfff0a",
  null
  
)

export default component.exports